module.exports = __webpack_public_path__ + "assets/component.a69885f8.svg";